export enum SmsAutomationActions {
  BeginWeb = 'begin-web',
  BeginScheduled = 'begin-scheduled',
  FinishedSchedule = 'finished-schedule',
  LeftSchedule = 'left-schedule',
  SendSMs = 'send-sms',
  // Customer did not visit after X days
  CustomerDidntVisit = 'customer-didnt-visit',
  CustomerCanceled = 'customer-canceled',
  AmountOfDaysPassed = 'amount-of-days-passed'
}
